import { Crop } from 'react-image-crop';
import { useState, useRef, useEffect } from 'react';
import { QrTextPlacementType } from '../../helpers';

export const useWrappedQrCode = (
  crop?: Crop,
  label?: string,
  size: number = 50,
  logo?: string,
  labelPosition?: QrTextPlacementType,
) => {
  const qrCrop = crop
    ? {
        left: `${crop?.x}${crop?.unit}`,
        top: `${crop?.y}${crop?.unit}`,
        width: `${crop?.width}${crop?.unit}`,
        height: `${crop?.height}${crop?.unit}`,
      }
    : undefined;

  const [logoWithLabel, setLogoWithLabel] = useState(logo);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (label && logo) {
      const canvas = canvasRef.current;
      const ctx = canvas?.getContext('2d');
      const img = new Image();
      img.src = logo;

      img.onload = () => {
        if (canvas && ctx) {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          ctx.font = '4cm Arial';
          ctx.textAlign = 'right';
          ctx.fillStyle = labelPosition === 'center' ? 'black' : 'white';
          ctx.fillText(label, img.width, 100);
          setLogoWithLabel(canvas.toDataURL());
        }
      };
    } else {
      setLogoWithLabel(logo);
    }
  }, [label, logo, labelPosition]);

  if (size > 50) size = 50;
  if (size < 30) size = 30;

  return { qrCrop, logoWithLabel, canvasRef, logoSize: size };
};
